import { render, staticRenderFns } from "./CarrierNew.vue?vue&type=template&id=40458b08"
import script from "./CarrierNew.vue?vue&type=script&lang=js"
export * from "./CarrierNew.vue?vue&type=script&lang=js"
import style0 from "./CarrierNew.vue?vue&type=style&index=0&id=40458b08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports